import { html } from 'lit-element';
import { KatalComponent, KatLitElement } from '../../shared/base';
import baseStyles from '../../shared/base/base.lit.scss';
import styles from './box.lit.scss';

/**
 * @component {kat-box} Box A wrapper component for the kat-box utility classes
 * @guideline Do Boxes are best used as containers to hold content such as images and paragraphs.
 * @guideline Dont Do not use boxes to create spacing.
 * @example LtGreyBox {"variant":"ltgrey", "content":"Lorem ipsum"}
 * @example AzureBox {"variant":"azure", "content":"Lorem ipsum"}
 * @example WhiteBox {"variant":"white", "content":"Lorem ipsum"}
 * @example WhiteShadowBox {"variant":"white-shadow", "content":"Lorem ipsum"}
 * @example MojitoBox {"variant":"mojito", "content":"Lorem ipsum"}
 * @example ZirconBox {"variant":"zircon", "content":"Lorem ipsum"}
 * @example WhiteJunglemistBox {"variant":"white-junglemist", "content":"Lorem ipsum"}
 * @example NordicBox {"variant":"nordic", "content":"Lorem ipsum"}
 * @status Production
 * @theme flo
 * @contentProvided
 */
class KatalBox extends KatLitElement {
  static get properties() {
    return {
      /**
       * @classprop {enum} variant The Flow-style variant of the box
       * @enum {value} ltgrey Light grey box with no border
       * @enum {value} azure Azure box with no border
       * @enum {value} white white box with a light grey 1px solid border
       * @enum {value} white-shadow white box with a light grey 1px border and a drop shadow
       * @enum {value} mojito Mojito box with no border
       * @enum {value} zircon Zircon box with no border
       * @enum {value} white-junglemist White Junglemist box with no border
       * @enum {value} nordic Nordic box with no border and white font color
       */
      variant: { type: String, reflect: true },
    };
  }

  static get styles() {
    return [baseStyles, styles];
  }

  render() {
    return html`<slot></slot>`;
  }
}

KatalComponent.register('kat-box', KatalBox);
